module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"contact":{"singular":"contact","plural":"contacts"},"company":{"singular":"company","plural":"companies"},"deleteWarningHeader":"Delete this custom field","deleteWarning":"If you delete this custom {recordType}, you will also lose all the data stored in it across all {pluralRecordType}.","permanent":"This action is permanent.","deleteAction":"Delete field"}}')
  delete Component.options._Ctor
}
